import React from 'react'
import { Dialog, DialogPanel, DialogTitle, DialogBackdrop } from '@headlessui/react'

export default function ConfirmDialog({ open, onClose, onConfirm, title, message, confirmLabel = 'Confirm', danger = false }) {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <DialogBackdrop className="fixed inset-0 bg-black/40 backdrop-blur-sm" />
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <DialogPanel className="glass-card w-full max-w-md p-6">
          <DialogTitle className="text-lg font-semibold text-gray-900 dark:text-white mb-3">
            {title}
          </DialogTitle>
          <p className="text-sm text-gray-600 dark:text-gray-400 mb-6">
            {message}
          </p>
          <div className="flex justify-end gap-3">
            <button
              onClick={onClose}
              className="glass-btn-secondary glass-btn-sm"
            >
              Cancel
            </button>
            <button
              onClick={() => { onConfirm(); onClose() }}
              className={`glass-btn-sm ${danger ? 'glass-btn-danger' : 'glass-btn-primary'}`}
              autoFocus
            >
              {confirmLabel}
            </button>
          </div>
        </DialogPanel>
      </div>
    </Dialog>
  )
}
